import previousSearches from './previousSearch/reducer';
import currentSearch from './currentSearch/reducer';
import topDestinations from './topDestinations/reducer';
import geoLocations from './geoLocations/reducer';
import flexibleDates from './flexibleDates/reducer';
import locationAutocomplete from './locationAutocomplete/reducer';
import activeProduct from './activeProduct/reducer';
import userAuthentication from './userAuthentication/reducer';
import asyncSearch from './asyncSearch/reducer';

const combineReducers = (reducers) => (state = {}, action) =>
    Object.entries(reducers).reduce(
        (result, [name, fn]) => ({
            ...result,
            [name]: fn(result[name], action, result),
        }),
        state,
    );

export default combineReducers({
    activeProduct,
    currentSearch,
    flexibleDates,
    geoLocations,
    locationAutocomplete,
    previousSearches,
    topDestinations,
    userAuthentication,
    asyncSearch,
});
